<div class="course-items-switch-wrapper">
    <ng-container [ngSwitch]="display">
        <ng-container *ngSwitchCase="ResourceBuildingItems.SCORM_LIBRARY">
            <mat-tab-group class="res-tabs-course-item" #tabGroup ngClass.xs="xs">
                <mat-tab>
                    <ng-template mat-tab-label i18n> My SCORMs </ng-template>

                    <app-resource-library-multiple-select
                        [type_scope_id]="AppScope.SCORM"
                        context="author"
                        [selection]="selection"
                        [columns]="['select', 'title', 'updated_at', 'published', 'scorm_error', 'language']"
                        (onSubmitMultiSelect)="onMultiSelect.emit({ res: $event, isParentSubmission: false })"
                        (selectChange)="selectChange.emit($event)"
                        ><ng-container [ngTemplateOutlet]="topSubmitBtn"></ng-container
                    ></app-resource-library-multiple-select>
                </mat-tab>
                <mat-tab>
                    <ng-template mat-tab-label i18n> Academy SCORMs </ng-template>

                    <app-resource-library-multiple-select
                        [type_scope_id]="AppScope.SCORM"
                        context="academy"
                        [selection]="selection"
                        [columns]="['select', 'title', 'updated_at', 'published', 'scorm_error', 'language']"
                        (onSubmitMultiSelect)="onMultiSelect.emit({ res: $event, isParentSubmission: false })"
                        (selectChange)="selectChange.emit($event)"
                        ><ng-container [ngTemplateOutlet]="topSubmitBtn"></ng-container
                    ></app-resource-library-multiple-select>
                </mat-tab>

                <mat-tab>
                    <ng-template mat-tab-label i18n> Open library (KOL) </ng-template>

                    <app-resource-library-multiple-select
                        [type_scope_id]="AppScope.SCORM"
                        context="kol"
                        [selection]="selection"
                        [columns]="['select', 'title', 'updated_at', 'published', 'scorm_error', 'language']"
                        (onSubmitMultiSelect)="onMultiSelect.emit({ res: $event, isParentSubmission: false })"
                        (selectChange)="selectChange.emit($event)"
                        ><ng-container [ngTemplateOutlet]="topSubmitBtn"></ng-container
                    ></app-resource-library-multiple-select>
                </mat-tab>
            </mat-tab-group>
        </ng-container>
        <ng-container *ngSwitchCase="ResourceBuildingItems.CREATE_NEW_SCORM">
            <app-course-manager-create-scorm
                #compRef
                class="create-test-in-course-manager"
                (published)="add.emit($event)"
                (onError)="onError.emit($event)"
            ></app-course-manager-create-scorm>
            <!-- <app-course-manager-create-scorm
                #compRef
                [resource]="resourceToEdit"
                [publishOnly]="true"
                publishLabel="Add to course"
                i18n-publishLabel
                (published)="add.emit($event)"
                (onError)="onError.emit($event)"
            ></app-course-manager-create-scorm
        > -->
        </ng-container>
    </ng-container>
    <button
        matTooltip="Trash"
        mat-icon-button
        [ngClass]="display === ResourceBuildingItems.SCORM_LIBRARY ? 'lib' : 'normal'"
        (click)="display = null; onCloseView.emit(true)"
        i18n-matTooltip
        class="add-creation-tab"
    >
        <mat-icon>cancel</mat-icon>
    </button>
</div>
<ng-template #topSubmitBtn>
    <button
        *ngIf="!!selectedResources?.length"
        class="topsubmitBtn"
        mat-button
        color="primary"
        (click)="onSubmitMultiple()"
    >
        <span i18n>Done ({{ selectedResources?.length }})</span>
    </button>
</ng-template>
